module.exports = __webpack_public_path__ + "img/join-coin-network-image.daf3fd53.png";